import { css } from 'styled-components';
import { VariantOfType } from '../../variants';

export const CssRadioOptionDefault = css`
`;

export const radioOptionVariants = {
  default: CssRadioOptionDefault,
};

export type IRadioOptionVariants = VariantOfType<typeof radioOptionVariants>;
